module.exports = __webpack_public_path__ + "static/forms-multiple-fields-progress-do-411ef0326972b3cf823fbda6e56871b2.png";